import { Pipe, PipeTransform } from '@angular/core';

const regexSkipHtmlOrLongVowelMark = /<[^>]*>|:/g;

@Pipe({
  name: 'rmLongVowel'
})
export class RmLongVowelPipe implements PipeTransform {

  transform(content: string | null | undefined): string | null {
    return content ? content.replace(regexSkipHtmlOrLongVowelMark, (match) => {
      if (match.startsWith('<')) {
        return match;
      }
      return '';
    }) : null;
  }

}
